const { Routes } = require('@common-packages/routes-definitions');

module.exports = routeDefinition => routeDefinition === Routes.customScreen.MAIN;
